import type { ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ParsingRulesPage } from '~/components/parsing-rules/ParsingRulesPage';

/**
 * Public explainer of how uploaded values are parsed. Standalone (no app shell, no
 * auth) so it can be linked to a customer directly, mirroring `/style-guide`.
 */
export const Route = createFileRoute('/parsing-rules')({
  component: ParsingRulesRoute,
});

function ParsingRulesRoute(): ReactNode {
  return <ParsingRulesPage />;
}
